<template>

<v-card color="basil" flat>
          
          <v-card>
<v-progress-linear :active="loading" color="red" indeterminate rounded absolute height="5"></v-progress-linear>




    <v-data-table
      :headers="headers"
      :items="desserts"
      sort-by="calories"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar
          flat
        >
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-spacer></v-spacer>
          <v-dialog
            v-model="dialog"
            width="1000px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                class="mb-2"
                v-bind="attrs"
                v-on="on"
              >
                Novo
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ formTitle }}</span>
              </v-card-title>
  
              <v-card-text>
                <v-container>

<!-- <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                    >
                      
                      <div class="container">
      <h2>Upload file</h2>
      <vue-base64-file-upload 
        class="v1"
        accept="image/png,image/jpeg"
        image-class="v1-image"
        input-class="v1-image"
        @file="onFile"
        @load="onLoad" />
    </div>

                    </v-col>
                  </v-row> -->


                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                    >
                      <v-text-field
                        v-model="editedItem.Nome"
                        label="Nome"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                    >
                      <v-text-field
                        v-model="editedItem.Cupom"
                        label="Cupom"
                      ></v-text-field>
                    </v-col>
                  </v-row>


                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                    >
                      <v-text-field
                        v-model="editedItem.Email"
                        label="Email"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                    >
                      <v-text-field
                        v-model="editedItem.Telefone"
                        label="Celular"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                    >
                      <v-textarea
                        v-model="editedItem.ContaBancaria"
                        label="ContaBancaria"
                      ></v-textarea>
                    </v-col>
                  </v-row>



                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                    >

                    <quill-editor
                      v-model="editedItem.Descricao"
                      ref='textEditor'
                      :options='editorOption'
                    ></quill-editor>

                  
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
  
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="close"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="save"
                >
                  Salvar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editItem(item)"
        >
          {{ icons.mdiPencil }}
        </v-icon>
        <!--<v-icon
          small
          @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon> -->
      </template>
      <template v-slot:no-data>
        <v-btn
          color="primary"
          @click="getPagos"
        >
          Reset
        </v-btn>
      </template>
    </v-data-table>      
          
          
          
          </v-card>


        </v-card>
       
</template>
<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
 import Vue from 'vue'
import { quillEditor } from 'vue-quill-editor'
import main from '../assets/scripts/main.js';
import VueBase64FileUpload from 'vue-base64-file-upload';
import {
  mdiPencil
} from '@mdi/js'

  export default {
    name: 'Home',
    components: {
      quillEditor,
      VueBase64FileUpload
    },
    
    props: ['usuario'],
    data: () => ({
      icons: {
        mdiPencil
      },
      fileImage: null,
      imagem: "https://motormac.com.br/wp-content/themes/consultix/images/no-image-found-360x250.png",
      editorOption: { /* quill options */ },
      loading: true,
      dialog: false,
      dialogDelete: false,


      headers: [
        { text: 'Nome', value: 'Nome' },
        { text: 'Cupom', value: 'Cupom' },
        { text: 'Email', value: 'Email' },
        { text: 'Telefone', value: 'Telefone' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      

      desserts: [],
      editedIndex: -1,
      editedItem: {
        Nome: '',
      },
      defaultItem: {
        Nome: 'teste',
      },
    }),
    computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Novo' : 'Editar'
    },
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    dialogDelete (val) {
      val || this.closeDelete()
    },
  },
    created(){
        this.getPagos();
    },
    methods: {

    onFile(file) {
      this.fileImage = file
    },

    onLoad(dataUri) {
      this.imagem = dataUri;
    },
      async getPagos () {
        var eu = this;
        if(localStorage.getItem('cedeppeToken') != undefined && localStorage.getItem('cedeppeToken')  != null){
          var req = {
            token: localStorage.getItem('cedeppeToken'),
            direcao: 'Entrada',
            status: 'aprovados'
          };
          var resp = await main.postApi(req, "admin/pegarUsuariosCompleto");
          var retorno = await resp.json();
          if(retorno.sucesso){
            this.imagem = retorno.corpo.FotoPerfil;
            this.desserts = retorno.corpo;
            this.loading = false;
          }
          else{
            this.loading = false;
            this.snackbar = true;
            this.msgSnack = retorno.erros
          }
        }
        else{
          this.deslogarvariaveis();
        }
      },
      editItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.desserts.splice(this.editedIndex, 1)
        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      async save () {
        // this.imagem = this.imagem.replace("data:image/jpeg;base64,", "");
        // this.imagem = "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"

        if (this.editedIndex == -1) {
            var eu = this;
            if(localStorage.getItem('cedeppeToken') != undefined && localStorage.getItem('cedeppeToken')  != null){
              var req = {
                token: localStorage.getItem('cedeppeToken'),
                id: '0',
                nome: this.editedItem.Nome,
                cupom: this.editedItem.Cupom,
                email: this.editedItem.Email,
                descricao: this.editedItem.Descricao,
                conta: this.editedItem.ContaBancaria,
                foto: this.imagem,
                celular: this.editedItem.celular
              };

              var resp = await main.postApi(req, "admin/EditarUsuario");
              var retorno = await resp.json();
              if(retorno.sucesso){
                this.getPagos();
              }
              else{
                this.loading = false;
                this.snackbar = true;
                this.msgSnack = retorno.erros
              }
            }
            else{
              this.deslogarvariaveis();
            }
        }
        else{
          var eu = this;
          if(localStorage.getItem('cedeppeToken') != undefined && localStorage.getItem('cedeppeToken')  != null){
            var req = {
              token: localStorage.getItem('cedeppeToken'),
              id: this.editedItem.Id,
              nome: this.editedItem.Nome,
              cupom: this.editedItem.Cupom,
              email: this.editedItem.Email,
              descricao: this.editedItem.Descricao,
              conta: this.editedItem.ContaBancaria,
              foto: this.imagem,
              celular: this.editedItem.celular
            };

            var resp = await main.postApi(req, "admin/EditarUsuario");
            var retorno = await resp.json();
            if(retorno.sucesso){
              this.getPagos();
            }
            else{
              this.loading = false;
              this.snackbar = true;
              this.msgSnack = retorno.erros
            }
          }
          else{
            this.deslogarvariaveis();
          }
        }
        this.close()
      },

      
    }
  }
</script>
